import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import "./styles/index.css";
import "@rainbow-me/rainbowkit/styles.css";
import App from "./App.tsx";
import { ReactQueryProvider } from "./providers/ReactQueryProvider.tsx";
import { env } from "./config/env";
import { TonConnectUIProvider } from "@tonconnect/ui-react";
import "./i18n";
import { Buffer } from "buffer";
import { useUserStore } from "./modules/auth/store/user.ts";
import { logger } from "./shared/utils/logger.ts";
import { WagmiProvider } from "wagmi";
import { RainbowKitProvider } from "@rainbow-me/rainbowkit";
import { wagmiConfig } from "./shared/utils/wagmi.ts";

window.Buffer = Buffer;

declare const __APP_VERSION__: string;
console.log(`[App] v${__APP_VERSION__}`);

if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register("/service-worker.js", { type: "module" });
}

if (env.isDevelopment || env.isLocal) {
  import("eruda").then((eruda) => eruda.default.init());

  useUserStore.subscribe((state) => {
    logger.debug("🧠 Zustand updated:", state);
  });

  (window as any).useUserStore = useUserStore;
}

export const AppTree = () => (
  <TonConnectUIProvider manifestUrl={env.manifestUrl}>
    <ReactQueryProvider>
      <WagmiProvider config={wagmiConfig}>
        <RainbowKitProvider modalSize="compact">
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </RainbowKitProvider>
      </WagmiProvider>
    </ReactQueryProvider>
  </TonConnectUIProvider>
);

const RootComponent = env.isLocal ? (
  <AppTree />
) : (
  <StrictMode>
    <AppTree />
  </StrictMode>
);

createRoot(document.getElementById("root")!).render(RootComponent);
